import {apiClient} from '@/services/auth-header';

const API_URL = '/auth';

class AuthService {
    login(user) {
        return apiClient
            .post(API_URL + '/login', {
                accountId: user.accountId,
                accountPwd: user.accountPwd
            })
            .then(response => {
                if (response.data.accessToken) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }
                return response.data;
            });
    }
    logout() {
        localStorage.removeItem('user');
    }
}

export default new AuthService();
